// Module
var code = "<div class=\"variant\">\n  <div ui-view></div>\n</div>\n";
// Exports
module.exports = code;